export default {
  common: {
    login: 'Login',
    signup: 'Sign Up',
    usd: 'USD',
    agentid: 'Agent ID',
    logout: 'Log Out',
    liveTime: '24/7 Live Assistance',
    callUs: 'Call Us',
    followUs: 'Follow Us',
    payMethods: 'Payment Methods',
    inSupportOf: 'In Support Of',
    copyright: 'All Rights Reserved',
    policy: 'Policy',
    membership: 'Membership',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribe',
    showMore: 'Show more',
    showLess: 'Show less',
    productSelector: {
      placeholder: 'Search by name or code'
    },
    months: {
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Aug',
      sep: 'Sep',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dec'
    },
    longMonths: {
      jan: 'January',
      feb: 'February',
      mar: 'March',
      apr: 'April',
      may: 'May',
      jun: 'June',
      jul: 'July',
      aug: 'August',
      sep: 'September',
      oct: 'October',
      nov: 'November',
      dec: 'December'
    },
    reset: 'Reset',
    confirm: 'Confirm',
    flightIncluded: 'Flights included',
    somethingWrong: 'Something wrong',
    moreThan: 'More than',
    more: 'more',
    year: 'Year',
    month: 'Month',
    days: 'Days',
    hour: 'Hour',
    hours: 'Hours',
    mins: 'Mins',
    secs: 'Secs',
    nights: 'Nights',
    person: 'person',
    points: 'Points',
    tours: 'Tours',
    packages: 'Packages',
    hotels: 'Hotels',
    flights: 'Flights',
    flight: 'Flight',
    attractions: 'Attractions',
    cruises: 'Cruises',
    cruise: 'Cruise',
    search: 'Search',
    tourOnly: 'Tour only',
    from: 'From',
    off: 'OFF',
    independent: 'Independent',
    semiGuided: 'Semi-Guided',
    escorted: 'Escorted',
    luxury: 'Luxury',
    semiEscorted: 'Semi-Escorted',
    close: 'Close',
    closeWindow: 'Close Window',
    email: 'Email',
    password: 'Password',
    cantEmpty: 'This field cannot be empty',
    enterEmail: 'Please enter the correct email',
    emailAddress: 'Email Address',
    enterName: 'Please enter the correct name',
    enterCorrectPhone: 'Please enter the correct Phone Number',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    phoneNumber: 'Phone Number',
    verification: 'Verification',
    verificationCode: 'Verification Code',
    verified: 'Verified',
    resend: 'Resend',
    getCode: 'Get Code',
    confirmPassword: 'Confirm Password',
    SUCCESSFUL: 'SUCCESSFUL',
    share: 'Share',
    save: 'Save',
    groupSize: 'Group Size',
    tourCode: 'Tour Code',
    included: 'Included',
    excluded: 'Excluded',
    destinationConcierge: 'Destination Concierge',
    age: 'Age',
    operatedIn: 'Operated in',
    operator: 'Operator',
    curatedBy: 'Curated By',
    firstGlance: 'First Glance',
    day: 'Day',
    night: 'Night',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    englishS: 's',
    englishEs: 'es',
    includedActivities: 'Included Activities',
    readMore: 'Read more',
    readLess: 'Read less',
    hideDetails: 'Hide details',
    stars: 'Stars',
    wiFiNotIncluded: 'Wi-Fi Not Included',
    additionalFeatures: 'Additional Features',
    details: 'Details',
    detail: 'Detail',
    travelDocumentVisas: 'Travel Document & Visas',
    travelersReviews: "Travelers' Reviews",
    addReview: 'Add Review',
    reviews: 'reviews',
    newest: 'Newest',
    oldest: 'Oldest',
    highest: 'Highest',
    lowest: 'Lowest',
    showMoreReviews: 'Show More Reviews',
    documentVisas: 'Document & Visas',
    operatorPolicy: 'Operator Policy',
    priceWas: 'Was',
    now: 'Now',
    dayOrder1: 'Day',
    dayOrder2: '',
    wiFiIncluded: 'Wi-Fi Included',
    freeCable: 'Free Cable',
    cableFee: 'Cable Fee',
    accommodation: 'Accommodation',
    transportation: 'Transportation',
    guidedTour: 'Guided Tour',
    withAdditionalFeatures: 'with additional features',
    internationlAirfare: 'International Airfare',
    airfare: 'Airfare',
    withDomesticFlight: 'with domestic flight',
    meals: 'Meals',
    specialLodge: 'special lodge',
    localbest: 'Local Best',
    english: 'English',
    mostRecent: 'Most Recent',
    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    depart: 'Depart',
    start: 'Start',
    return: 'Return',
    end: 'End',
    dates: 'Dates',
    bestPrice: 'Best Price',
    priceDrop: 'Price drop',
    cancel: 'Cancel',
    departureCity: 'Departure City',
    travelDetails: 'Travel Details',
    yearExt: '',
    dayExt: '',
    duration: 'Duration',
    departureDate: 'Departure Date',
    tourStarts: 'Tour Starts',
    returnDate: 'Return Date',
    tourEnds: 'Tour Ends',
    rooms: 'Room Allocation',
    room: 'Room',
    continue: 'Continue',
    adults: 'Adults',
    ages18OrAbove: 'Aged 18 or above',
    ages3_17: 'Aged 3 - 17',
    children: 'Children',
    confirmChanges: 'Confirm Changes',
    traveler: 'Traveler',
    travelers: 'Travelers',
    travelerUnit: '',
    submit: 'Submit',
    somethingError: 'Something error!',
    ages12OrAbove: 'Ages 12 or above',
    ages3_11: 'Ages 3 - 11',
    pleaseSelect: 'Please Select',
    register: 'Register',
    tripToGo: 'TripToGo',
    account: 'Account',
    telephone: 'Telephone',
    name: 'Name',
    gender: 'Gender',
    surname: 'Surname',
    givenName: 'Given name',
    male: 'Male(M)',
    female: 'Female(F)',
    undisclosed: 'Undisclosed(U)',
    unspecified: 'Unspecified(X)',
    birthday: 'Birthday',
    MM: 'MM',
    DD: 'DD',
    YYYY: 'YYYY',
    address: 'Address',
    edit: 'Edit',
    country: 'Country',
    province: 'State/Province',
    city: 'City',
    postalCode: 'Postal Code',
    selectCountry: 'Select Country',
    copy: 'Copy',
    copied: 'Copied',
    people: 'People',
    description: 'Description',
    status: 'Status',
    invalidDate: 'Invalid Date',
    back: 'Back',
    expired: 'Expired',
    copiedSuccessfully: 'Copied Successfully',
    sharedSuccessfully: 'Shared Successfully',
    url: 'Url',
    formSave: 'Save',
    other: 'Other'
  },
  menu: {
    newsletter: 'Newsletter',
    network: 'Traveler Network',
    mystory: 'My Stories',
    shareJourney: 'Storyteller Program',
    myinquiry: 'My Inquiries',
    mywallet: 'My Wallet',
    mybookings: 'My Bookings',
    myVouchers: 'My Vouchers',
    Wishlist: 'Wishlist',
    personal: 'Personal Info',
    promotion: 'Promotion',
    commission: 'Commission',
    cashback: 'Affiliate Program',
    partner: 'Partner',
    company: 'Company',
    aboutUs: 'About Us',
    largeGroupPartnership: 'Large Group Partnership',
    partneringWith: 'Partnering with TripToGo',
    workingWith: 'Working with TripToGo',
    operatorPortal: 'Operator Portal',
    operatorRegistration: 'Operator Registration',
    agentsLogIn: 'Agents Log In',
    agentRegistration: 'Agent Registration',
    agentFAQ: 'Agent FAQ',
    contactUs: 'Contact Us',
    agentContactUs: 'Travel Agent Support',
    travelInsurance: 'Travel Insurance',
    travelProtection: 'Travel Protection',
    general: 'General',
    privacy: 'Privacy',
    fefund: 'Refund',
    cookies: 'Cookies',
    joinNow: 'Join Now',
    visaAdvisory: 'Visa Advisory',
    visaApplication: 'Visa Application',
    travelServiceProviders: 'Travel Service Providers',
    travelAgents: 'Travel Agents',
    visaAssistance: 'Visa Assistance',
    membership: 'Membership',
    support: 'Support',
    faq: 'FAQ'
  },
  home: {
    southernAfrica: 'Southern Africa',
    southernAfricaDesc: '20 Unforgettable Experiences Across Southern Africa',
    eastAfrica: 'East Africa',
    eastAfricaDesc: '21 Things You Have to See in East Africa',
    turkey: 'Türkiye',
    turkeyDesc: 'Wondrous Tükiye: Where East Melts into West',
    redefineTheJourney: 'Redefine The Journey',
    saleEnds: 'Sale Ends',
    discoverSouthAmerica: 'Discover South America',
    Star5ToursatUnbeatablePrices: '5-Star Tours at Unbeatable Prices',
    star5Toursat: '5-Star Tours at',
    unbeatablePrices: 'Unbeatable Prices',
    japan: 'Japan',
    japanDesc: 'A Classic First Visit to Japan',
    readOurBlog: 'Read our blog',
    egypt: 'Egypt',
    egyptDesc: "The Nile, the Desert, and the Divine: Egypt's Eternal Allure",
    taiwan: 'Taiwan',
    taiwanDesc: 'City Lights to Sacred Sites and Beyond',
    peru: 'Peru',
    peruDesc: 'A Journey Through Time and Culture',
    toursTogo: 'Tours ToGo',
    toursTogoDesc:
      'Explore Tours ToGo options, available in Escorted, Semi-Escorted, and Luxury categories. Each tour offers unique experiences, from fully guided to more flexible journeys. Flights are not included but can be conveniently added to customize your travel experience.',
    flexiblePackages: 'Flexible Packages',
    trustedPartners: 'Trusted Partners',
    globalDestinations: 'Global Destinations',
    easyPlanning: 'Easy Planning',
    costEffective: 'Cost-Effective',
    discoverMore: 'Discover More',
    productCollectionType: 'Product collection type',
    tripToGoTourCollections: 'TripToGo Tour Collections',
    tripToGoTourCollectionsDesc:
      'Travel confidently with carefully curated tours directly sourced by TripToGo and operated by a network of trusted travel partners. With fellow TripToGo members by your side, enjoy itineraries selected for quality, value, and a seamless travel experience.',
    joinInGroupTour: 'Join-In Group Tour',
    ttgCollection: 'TTG Collection',
    joinInGroup: 'Join-In Group',
    joinInGroupTourDesc:
      'Join a shared group tour designed and operated by trusted local travel partners. Your fellow travelers may include guests from outside the TripToGo community, giving you a wider mix of people to meet and often more availability.',
    tripToGoPackageCollections: 'TripToGo Package Collections',
    tripToGoPackageCollectionsDesc:
      'Designed by TripToGo with a network of trusted travel partners, these packages feature well-designed routes, handpicked hotels, and signature excursions that bring out the best of each destination. For travelers who want a thoughtfully planned trip with local flavor and seamless logistics—all in one bundle.',
    joinInGroupPackages: 'Join-In Group Packages',
    joinInGroupPackagesDesc:
      'Operated by a network of trusted travel partners, these packages include flights, hotels, and classic, widely available excursions. Best for travelers who want a simple, value-driven bundle without extra curation.',
    packageToGo: 'Package ToGo',
    packageToGoDesc:
      'Experience effortless travel with our Flight Included Trip. Book your round-trip flight and hotel in one seamless package, simplifying your journey from start to finish. Enjoy the convenience of one-stop booking and embark on your adventure with ease.',
    flightsIncluded: 'Flights Included',
    multipleDestinations: 'Multiple Destinations',
    destinationConcierge: 'Destination Concierge',
    upgradableHotels: 'Upgradable Hotels',
    curatedTours: 'Curated Tours',
    recommended: 'Recommended',
    recommendedDesc:
      'Our team of travel experts have carefully selected popular destinations that stand out for their exceptional experiences, cultural richness, and scenic beauty.',
    recommended1: 'Traveler Favorites',
    recommended2: 'Trusted Partners',
    recommended3: 'Global Destinations',
    recommended4: 'Diverse Options',
    recommended5: 'Seamless Experience',
    newslettersToGo: 'Newsletters ToGo',
    newslettersToGoDesc:
      'Sign up to receive promotions, rewards, and travel inspirations for your next Trip ToGo!',
    dontMiss: "You Don't Want To Miss",
    traverNetwork: 'TripToGo Travelers Network',
    referAFriend: 'Refer a friend',
    earnUpTo: 'Earn up to',
    Rewards100: '$100 Rewards',
    earnNow: 'Earn Now',
    tripToGoMembership: 'TripToGo Membership',
    earnUpTo100: 'Earn up to 100 in Reward Points',
    discoverPeru: 'Discover Peru',
    discoverPeruDesc:
      'Uncover the secrets of the Inca Empire and the breathtaking landscapes of the Andes.',
    adventureAlliance: 'Adventure Alliance',
    adventureAllianceDesc: 'Rally your crew of 10 or more for an unforgettable journey!',
    recentlyViewed: 'Recently Viewed Deals',
    theTripToGoDifference: 'The TripToGo Difference',
    whatTravelersSay: 'What TripToGo Travelers Say',
    enterEmail: 'Enter your email',
    differ_1: 'Customer Care',
    differDesc_1:
      'We provide 24/7 support, swiftly resolve issues, and prioritize seamless, high-quality experiences for customers and suppliers.',
    differ_2: 'Direct Connections',
    differDesc_2:
      'We connect travelers directly with global destinations, experts, and travel partners in one unified platform.',
    differ_3: 'Transparent Pricing',
    differDesc_3:
      'We offer transparent pricing, no hidden fees, and exclusive savings through direct, long-standing travel industry partnerships.',
    differ_4: 'Comprehensive Solutions',
    differDesc_4:
      'TripToGo is a one-stop platform offering personalized travel planning and seamless, convenient booking experiences.',
    differ_5: 'Forward Thinking',
    differDesc_5:
      'Advanced technology powers seamless booking, smart connectivity, and AI-driven personalization, continuously enhancing the TripToGo travel experience.',
    featured1: 'Featured',
    featured2: 'Destinations',
    black5: 'Black Friday Starts Now',
    black5Title2: 'Black Friday Starts Now!',
    black5Title3: 'New Hot Deals Every Week',
    black5Link: 'More Black Friday Offers',
    black5Desc:
      'Our team has sourced the finest selections from our global partners to craft the ultimate Black Friday collection, just for our members.',
    cyber: 'Cyber Week Starts Now!',
    cyberLink: 'More Cyber Week Deals',
    cyberDesc:
      'Our team has sourced the finest selections from our global partners to craft the ultimate Cyber Week deals collection, just for our members.',
    weekly_1: 'Weekly Top Deals',
    weeklyDesc_1:
      'Each week, we scour the globe to bring our valued members the very best in travel savings. Our weekly selection features unparalleled prices on top destinations and experiences, all curated to help you create unforgettable memories.',
    weekly_2: 'Trending',
    weeklyDesc_2:
      "Our advanced data-driven algorithms bring you Trending Deals for the destinations everyone's buzzing about.",
    weekly_3: 'Surprise Deal Rush',
    weeklyDesc_3:
      "Deals this good won't last! New offers come and go, and for a limited time, all membership tiers can grab exclusive perks usually reserved for Voyager & Elite members. This is the LAST chance to grab Surprise Deal Rush as an open offer for ALL members! Check back often and lock in your deal before it's gone!",
    weekly_4: 'Exclusive Access',
    weeklyDesc_4:
      'Unlock Exclusive Access Deals, available only to our Voyager and Elite members! Enjoy exceptional savings on top destinations and experiences, specially curated to elevate your next adventure!',
    weekly_mystery: 'Mystery ToGo',
    weeklyDesc_mystery:
      'Embark on the adventure of a lifetime. Book now and let the secret unfold as your surprise journey begins!',
    searchDesc: 'Stay tuned for this exciting new feature. Coming soon!',
    allCountry: 'All Countries',
    selectDate: 'Select Date',
    whereTo: 'Where To',
    subscriptionFailed: 'Subscription Failed',
    subscriptionSuccessful: 'Subscription Successful',
    weeklyHours: 'Hours',
    weeklyMins: 'Mins',
    aboutUs: 'About Us',
    aboutUsDesc: 'learn more about our vision and values.',
    readMore: 'read more',
    trustpilot: 'Trustpilot',
    googleReviewTitle: 'What TripToGo Travelers Have to Say',
    writeReview: 'Write a review',
    needSome: 'Need some',
    inspirations: 'Inspirations',
    featuredDestSubtitle: 'Read our latest blogs to create your next trip to go!',
    readAllBlogs: 'Read all blogs',
    travelerStoriesTitle: 'Traveler Stories',
    travelerStoriesSubtitle: "See our travelers' journeys through real stories and experiences",
    learnMore: 'Learn more',
    watchMoreVideos: 'Watch more videos',
    mins: 'mins',
    bookNow: 'Book Now',
    trustpilot: 'Trustpilot'
  },
  hotelDeal: {
    promoTitle: 'Hotel Deals for Members',
    bookNow: 'Book Now',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    roomType: 'Room',
    roomsCount: 'Rooms',
    adults: 'Adults',
    guestName: 'Guest name',
    nationality: 'Nationality',
    confirmAndPay: 'Confirm & Pay',
    bookingConfirmed: 'Booking Confirmed',
    viewDeal: 'View Deal →',
    saveUpTo: 'Save up to {n}%',
    fromPerNight: 'From {price} / night'
  },
  mysteryBox: {
    formTitle: 'Select Your Trip Details',
    formSub: 'Choose your departure month and number of travelers.',
    departureMonth: 'Departure Month & Year',
    selectDepartureDate: 'Please Select Departure Date',
    selectDepartureMonth: 'Please select a departure month.',
    selectDepartureCity: 'Please select a departure city.',
    nationality: 'Nationality',
    selectNationality: 'Select Nationality',
    travelerN: 'Traveler {n}'
  },
  login: {
    earnPoints: /*html*/ `Log in, share your code, and earn <span style="color: #4ca771">100 Points!</span>`,
    logIn: 'Log In',
    forgotPassword: 'Forgot Password?',
    createAnAccount: 'Create an Account',
    dontHave: "Don't have an Account yet?",
    success: 'LOGIN SUCCESSFUL',
    successDesc: 'Success! You have signed into your account. Please close this window and proceed.'
  },
  recover: {
    enterEmail: 'This email field cannot be empty',
    recoverMyPassword: 'Recover my Password',
    recoverYourPassword: 'Recover Your Password',
    desc: 'Please enter the email address you used to create your account, and we will send you a temporary password.',
    successDesc:
      'Success! A  temporary password sent to your email, please close this window and proceed to login.'
  },
  register: {
    sendCodeTips: 'verification code has been sent to your email & phone number',
    title: 'Create an Account',
    already: 'Already have an account?',
    successTitle: '',
    successDesc:
      'Congratulations! Your account has been successfully created. You can close this window and proceed.',
    couponGranted:
      '🎁 As a welcome gift, you\'ve received a {amount} OFF coupon (code: {code}). It has been added to your account and is valid for {days} days. The code was also sent to your email.',
    agreeTxt: /*html*/ `I have read and agree to the <span style="color: #1b80de; padding-left: 2px; text-align: left; line-height: 19px"><a href="/terms/?title=general" target="_blank" style="display: inline">Terms & Conditions</a></span>, I would like to receive notifications regarding exciting travel deals and exclusive  offers from TripToGo.`,
    smsText: /*html*/ `I agree to receive SMS messages from TripToGo.`,
    smsTextItems: /*html*/ `<li>Messaging frequency may vary.</li><li> Message and data rates may apply.</li><li> You can opt out at any time by texting STOP.</li><li> For assistance, text HELP or visit <span style="color: #1b80de; padding-left: 2px; text-align: left; line-height: 19px"><a href="https://www.triptogo.com" target="_blank" style="display: inline">https://www.triptogo.com</a></span>
    .</li><li> Visit <span style="color: #1b80de; padding-left: 2px; text-align: left; line-height: 19px"><a href="/terms/?title=privacy" target="_blank" style="display: inline">Privacy Policy</a></span>
    and <span style="color: #1b80de; padding-left: 2px; text-align: left; line-height: 19px"><a href="/terms/?title=general" target="_blank" style="display: inline">Terms of Service</a></span>.</li>`,
    regSuccess: 'Registration successful!',
    noMatch: 'Please make sure your passwords match',
    infoMissing: 'Almost there! Just a few more details to complete before we can move forward.',
    networkError:
      'Looks like our website is having a bit of a party, and it’s too packed right now! We’re experiencing technical difficulties due to all the registrations. Please swing by again later.',
    userExists:
      'Looks like you already have an account with us. Please log in to continue your journey!'
  },
  detail: {
    hotelsExperienceUpgrade: 'Hotels Experience & Upgrade',
    hotelsExperienceUpgradeDesc: `Our hotel selections (Classic, Deluxe, Prestige) are based on availability and seasonality. You may be assigned any hotel with similar standards during your stay.`,
    viewDatesPrices: 'View Dates & Prices',
    agentSellingPoints: 'Agent Selling Points',
    playVideo: 'Play video',
    KannaGuide: "Kanna's Guide",
    viewGallery: 'View gallery',
    believeDesc: `We believe in giving our members the best value and honest pricing. Our team of travel experts secures exclusive rates from trusted partners and compares them with market prices to bring you the best value possible. At TripToGo, you get clear comparisons, honest deals, and the confidence of knowing you're making the smartest travel choices.`,
    totalSavings: 'Total Savings(up to)',
    marketPrice: 'Market Price',
    trustedPartner: 'Trusted Partner',
    exclusiveOn: 'Exclusive on TripToGo',
    saveUpTo: 'save up to',
    scoopDesc: `*Our prices reflect the best available deals at the time of posting. As travel offers can change quickly, please be aware that prices and details may adjust without notice, but we'll always aim to keep you informed.`,
    bookNow: 'Book Now',
    bookingTutorial: 'Booking Tutorial',
    finalHour: 'Final Hours to Book Your Dream Getaway at a Discounted Rate!',
    bookWithoutFlights: 'Book without Flights',
    bookWithFlights: 'Book with Flights',
    redeemWithFlights: 'Redeem with Flights',
    askOperator: 'Ask Operator',
    topThingsToSee: 'Top Things to See',
    whatToExpect: 'What To Expect',
    WhatsIn: "What's In",
    WhatsOut: "What's Out",
    tripItinerary: 'Trip Itinerary',
    downloadFlyer: 'Download Flyer',
    downloadItinerary: 'Download itinerary',
    expandAllDays: 'Expand all days',
    collapseAllDays: 'Collapse all days',
    tripBy: 'Trip by',
    youMightAlsoLike: 'You Might Also Like',
    travelTips: 'Travel Tips',
    domesticFerry: 'Domestic Ferry',
    ferryRides: 'Ferry Rides',
    atFamousIslands: 'at famous islands',
    niceReviews: 'Nice reviews',
    omesticAirfare: 'Domestic Airfare',
    beijingToShanghai: 'Beijing to Shanghai',
    withinHalfAnHour: 'Within half an hour',
    withinOneHour: 'Within one hour',
    withinTwoHour: 'Within Two hour',
    days4AndMore: '4 days and more',
    insideScoop: 'Inside Scoop',
    selectADay: 'Select a day',
    selectADayToGo: 'Select a day to go to next step',
    selectYourDepartureCity: 'Select your departure city',
    selectADate: 'Select a date',
    mysteryNoRedeemDates: 'No departures are available in your Mystery redemption month. Please contact us, or try redeeming without flights.',
    enterYourCity: 'Enter your Departure City',
    clickADate: 'Click a date to book online',
    datesPrices: 'Dates & Prices',
    setLeftOnly: 'Only',
    setLeft: 'set left',
    pleaseSelectADate: 'Please select a date',
    todoSorry:
      'Todo: Sorry, flight is unavilable, please contact our sale representive, page to TBA',
    limited: 'limited', //'Limited Availabilities Below 10 % left',
    soldOut: 'sold out', //'Sold out / currently unavailable',
    bestPrice: 'best price',
    priceDrop: 'price drop',
    regular: 'regular',
    rescheduled: 'rescheduled', //'For tour reschedule only',
    reservationInProgress: 'Reservation in progress',
    addMoreRooms: 'Add more rooms',
    shareDetail: 'Share Details to a Friend!',
    enterYourfriendEmail: "Enter your friend's email address",
    enterYName: 'Enter your name',
    enterYEmail: 'Enter your email address',
    enterYFName: "Enter your friend's name",
    enterYFEmail: "Enter your friend's email",
    enterMessage: 'Enter message',
    shareSuccess: 'SHARE TRIP SUCCESSFUL',
    shareSuccessDesc:
      'Success! You have shared this trip to your friend. Please close this window and proceed.',
    sentSuccess: 'Message sent successfully! Thanks for your share!',
    fillInName: 'Please fill in your name!',
    fillInEmail: 'Please fill in your email!',
    fillInFName: "Please fill in your friend's name!",
    fillInFEmail: "Please fill in your friend's email!",
    wrongEmail: 'Your email is in the wrong format!',
    wrongFEmail: "Your friend's email is in the wrong format!",
    bookingInquiries: 'Booking Inquiries!',
    bookingInquiriesDesc:
      "Have questions about the tour? Leave a message for the operator below, and they'll get back to you within 48 business hours.",
    expectedTravelDate: 'Expected Travel Date',
    max: 'Max.',
    iHaveQuestion: 'I have question about',
    pleaseDesc: 'Please describe your question',
    questionSentSuccess: 'Question Sent Successfully!',
    questionSentSuccess1: 'Your question has been sent successfully',
    questionSentSuccess2:
      'will get back to you shortly. Follow up your conversation in My Inquiries under My Profile.',
    pleaseQuestion: 'Please enter your question.',
    pleaseEnterQuestion: 'Please enter the correct question',
    sentQuestionSuccess: 'Message sent successfully! Thanks for your inquiry!',
    age0_2: 'For children aged 0-2, contact our travel experts to book.',
    yourItineraryIsReady: 'Your ltinerary is ready!',
    itineraryDesc1: 'Enter your email to get the ',
    itineraryDesc2: ' itinerary right into your inbox.',
    itineraryAgree: ' I agree to receive exclusive TripToGo promotions by email.',
    itinerarySent: 'ltinerary Successfully Sent!',
    itinerarySentDesc: 'Check your inbox and let us know if you have any questions.'
  },
  about: {
    about: 'About',
    whoWeAre: 'Who We Are',
    whoeWeAreDesc:
      ' TripToGo is an exclusive membership platform that leverages cutting-edge technology to simplify and demystify vacation planning. With more than 30 years of industry expertise and unparalleled connections, we deliver unforgettable experiences in any destination. Our greatest joy is crafting once-in-a-lifetime journeys for our discerning members.',
    ourMission: 'Our Mission',
    ourMissionDesc:
      'Because we believe that travel should be accessible to everyone, from beginners to seasoned planners, our mission is to make every vacation as effortless and stress-free as possible.',
    ourVision: 'Our Vision',
    ourVisionDesc:
      'We are dedicated to revolutionizing the way travelers plan their trips and engage with the world.',
    our: 'Our',
    approach: 'Approach',
    title1: 'Forward Thinking',
    desc1:
      'Technology underpins everything we do. It powers our seamless booking platform and a mobile app that allows you to stay in touch with your tour guide, upload travel documents, get notifications, access and book deals, and share your photos and live videos. It enables us to revolutionize travel planning through an AI-driven marketplace and Kanna, our virtual travel agent that can make personalized recommendations and build itineraries. Our focus on technology ensures that your experience with TripToGo is excellent today and will be even better tomorrow.',
    title2: 'Customer Care',
    desc2:
      'We take exceptional care of our customers with a 24/7 care team, prompt remediation of issues, and a commitment to ensuring everything runs smoothly both for our suppliers and our customers. Delivering an enjoyable experience is our utmost priority.',
    title3: 'Direct Connections',
    desc3:
      'We facilitate direct connections to destinations, experts, and cultural experiences around the globe. Engage with specialists, fellow travelers, hoteliers, airlines, cruise lines, and tour operators all in one place.',
    title4: 'Transparent Pricing',
    desc4:
      "We offer straightforward, honest pricing with options to suit every budget. The direct connections we've cultivated after more than thirty years in the industry allow us to deliver savings you might not find on other sites. Our model eliminates surprise fees and inflated costs, providing access to the best prices available directly from travel providers.",
    title5: 'Comprehensive Solutions',
    desc5:
      'TripToGo serves as a one-stop shop for all travel planning and booking needs, providing personalized recommendations and a streamlined booking process — convenience comes standard.'
  },
  mmship: {
    mmshipRequired: "Membership Required—Here's Why!",
    joinUsToday: 'Join us today!',
    weExcited:
      "We're excited to offer you an exclusive travel package. Follow these simple steps to join our community and start enjoying exclusive benefits:",
    weSecure:
      "We secure exclusive travel experiences worldwide through strong partnerships and ever-evolving technology, delivering unbeatable prices and extraordinary journeys—straight from the source! Membership makes it all possible. Best of all, you can <b>cancel anytime and receive a refund for any unused months</b>, and <b>no auto-renewal</b>—you're always in control.",
    discoverTheBenefits: 'Discover the Benefits',
    signup: 'Sign up',
    logIn: 'Login',
    paymentSuccessful: 'Payment Successful',
    welcomeToTheTTG: 'Welcome To The TTG Family!',
    enjoyAccess:
      'Enjoy access to unbeatable prices, exclusive member perks, and many more! Start exploring your dream vacation today!',
    continueBooking: 'Continue Booking',
    continueBookingBlack5: 'Shop for Black Friday Deals',
    directToProfilePage: 'To My Profile',
    membershipPolicy: 'Membership Policy',
    membershipBenefits: 'Membership Benefits',
    seeDetails: 'View all Benefits',
    welcomePoints: 'Welcome Points',
    rewards: 'Reward Points',
    cancelationProtection: 'Cancellation Protection',
    weeklyDreamTripDraw: 'Weekly Dream Trip Draw',
    earlyAccess: 'Early Access to Promotions',
    exclusivePromotions: 'Exclusive Promotions',
    waivedTransactionFees: 'Waived Transaction Fees',
    complimentaryUpgrades: 'Complimentary Upgrades',
    welcomePackage: 'Welcome Package',
    birthdayFreebies: 'Birthday Freebies',
    freeTrips: 'Free Trips',
    bookOnTripToGo: 'Book on TripToGo',
    deposit: 'No Upfront Deposit',
    annually: 'annually',
    free: 'Free',
    renewal: 'Renewal',
    getStarted: 'Get Started',
    currentTier: 'Current Tier',
    changeTier: 'Downgrade',
    upgrade: 'Upgrade',
    unlock: 'Unlock',
    unlockWhen: 'Unlock when rewards points reach 500',
    welcomePointsTip: 'Receive points upon joining, redeemable at a rate of 1 point = $1 USD.',
    rewardsTip: 'Earn points on every eligible booking to save on future travel.',
    cancelationProtectionTip: 'Secure your money with a waiver of standard cancellation fees for requests confirmed prior to the balance due date.',
    weeklyDreamTripDrawTip: 'Members receive one entry each week into our thrilling lucky draw for a complimentary dream trip. Terms and conditions apply.',
    earlyAccessTip: 'Get first priority on limited-time deals and high-demand seat offers.',
    exclusivePromotionsTip: 'Access exclusive discounts, vouchers, and travel deals.',
    complimentaryUpgradesTip: 'Enjoy free upgrades and enhanced features.',
    birthdayFreebiesTip: 'Celebrate your birth month with exclusive gifts and special travel offers.',
    freeTripsTip: 'Eligibility for fully complimentary travel experiences.',
    bookOnTripToGoTip: 'Gain access to a selection of exclusive member-only deals available only through our platform.',
    welcomePackageTip: 'Receive curated gifts, refreshments, and in-room touches upon arrival.',
    waivedTransactionFeesTip: 'Save more by avoiding standard credit card and processing fees.',
    seeAllBenefits: 'See all Benefits',
    collapse: 'Collapse',
    close: 'Close',
    bestValue: 'Recommended',
    memberNumber: 'Member number',
    availableUntil: 'Available until',
    renewMembership: 'Renew Membership',
    pickYourPlan: "Pick your plan. We're got a pl an for you.",
    chooseYourMembershipPlan: 'Choose your membership plan',
    ourPricingTables: 'Our Pricing Tables',
    elite: 'Elite',
    hello: 'Hello',
    upgrade: 'Upgrade'
  },
  groupRegister: {
    organizeADream: 'Organize a Dream Vacation',
    withAGroup: 'with a Group of your Favorite People',
    joinTripToGo: "Join TripToGo's Adventure Alliance",
    rallyYour: 'Rally your crew of 10 or more for an unforgettable journey!',
    unlockA:
      'As the travel maestro, orchestrate the adventure and unlock a fantastic reward-either a complimentary spot just for you or a tempting discount that gets better with every additional friend you invite!',
    assembleYour: 'Assemble your squad!',
    enlist10:
      'Enlist 10 or more of your companions to relish the perks of embarking on a collective journey.',
    bookYourTrip: 'Book your trip',
    bookYourTripDesc:
      'Provide your contact details, and our dedicated specialist will reach out to assist you in booking the ideal trip for you and your group.',
    saveBig: 'Save big',
    saveBigDesc:
      'You may be eligible for a complimentary tour as the group leader or a discount for each member in your group.',
    primaryTravelerInformation: 'Primary traveler information',
    writeYourFirstName: 'Write your first name',
    writeYourLastName: 'Write your last name',
    writeYourEmail: 'Write your email',
    adultsMore12: 'Adults (>12)',
    children: 'Children (2-11)',
    infants: 'Infants (<2)',
    tripData: 'Trip data',
    departureDate: 'Departure Date',
    iAmFlexibl: 'I am flexible',
    iAmNotSure: 'I am not sure',
    selectRange: 'Select Range',
    howMuchDoYou: 'How much do you want to spend per person (without flights )?',
    howMuchDoYouIncluding: 'How much do you want to spend per person (including flights)?',
    selectCity: 'Select City',
    whereDoYouWantToGo: 'Where do you want to go?',
    selectDestination: 'Select Destination',
    sendAMessage:
      'Send a message to our travel expert. Please include your comments, questions or any other request.',
    writeYouMessageHere: 'Write you message here',
    iHaveReadAndAgree: 'I have read and agree to the',
    generalPolicy: 'General Policy.',
    send: 'SEND',
    successDesc: 'Congratulations! Your message has been successfully sent.',
    from: 'From',
    to: 'To',
    notSure: 'not sure'
  },
  withus: {
    welcome: 'Welcome to TripToGo: Redefine the journey',
    welcomeDesc:
      'TripToGo collaborates with top global airlines, hotels, cruise lines, railways and ground operators to deliver an extensive range of travel  options through our cutting-edge technology and 24/7 support channel. Our various programs, easy accessibility and competitive pricing make traveling smooth, secure and more rewarding than ever.',
    support24: '24/7 support channel',
    mutualGrowth: 'Mutual Growth',
    noHiddenFees: 'No Hidden Fees',
    famTrips: 'FAM trips',
    limitedTimeOffers: 'Limited Time Offers',
    extraPerks: 'Extra Perks for Exclusive Products',
    jointPromotions: 'Joint Promotions and Sales Events',
    excitedIncentive: 'Excited Incentive Programs Available',
    ourGlobal: 'Our Global Network',
    bringingTheWorld:
      'Bringing the world closer with our global trusted travel partners and icons to deliver seamless experiences',
    whyChoose: 'Why choose TripToGo as your preferred partner?',
    readyToJoinUs: 'Ready to Join Us?',
    registerEarly: 'Register early and enjoy the benefits sooner',
    registerNow: 'Register Now',
    hugeDatabase: 'Huge Database of Travelers',
    tailored: 'Tailored Tour Packages',
    global: 'Global Exposure',
    postTravel: 'Post Travel Customer Engagement',
    dynamic: 'Dynamic Pricing Models',
    strongSocial: 'Strong Social Media Presence',
    innovative: 'Innovative Marketing Strategies with Integrated AI',
    exclusive: 'Exclusive Deals',
    trusted: 'Trusted Brand Reputation'
  },
  operatorReg: {
    registerAs: 'Register as a Travel Service Provider',
    thanksForYour: "Thanks for your interest in TripToGo. We can't wait to grow with you!",
    joinTripToGo: 'Join TripToGo as a travel service provider',
    ifYourCompany:
      'If your company operates your own tours and would like to partner with TripToGo as a supplier, please register here.',
    alreadyRegistered: 'Already registered?',
    ifYouHave:
      'If you have a TripToGo account or your agency is already registered, please log in or speak to your manager about acquiring a new login.',
    beforeWeCan:
      "Before we can start growing together, you'll need to register as an operator. If you're a travel operator and not currently affiliated with TripToGo, please fill out the form below. Once you're approved, you'll be able to grant individual access to agents at your firm.",
    nameOfTheLegal: 'Name of the legal entity that will appear on commission cheques.',
    uploadLogoImage: 'Upload Logo Image',
    pleaseNote:
      '*Please note that we require one registration number to successfully process your application with TripToGo. Without it, your agency cannot be approved.',
    operatorAddress: 'Operator Address',
    operatorContact: 'Operator Contact Details',
    operatorEmail: 'Operator email address.',
    supplierPhoneNumber: " Supplier's Phone Number",
    agencyManager: 'Agency Manager',
    holdUp: "Hold up! This is NOT your contact information; it's for the manager of your agency.",
    other: 'Other',
    iHaveRead: 'I have read and agree to the Terms and Conditions.',
    registerSuccess: 'Resgier SUCCESSFUL',
    registerSuccessDesc:
      'Success! You have registerd successfully. Please close this window and proceed.',
    americanSociety: 'American Society of Travel Agents',
    codeUnitedState: '+1 (United State)',
    codeCanada: '+1 (Canada)',
    CLIANumber: 'CLIA Number',
    IATANumber: 'IATA Number',
    TIDSNumber: 'TIDS Number',
    ABTANumber: 'ABTA Number',
    TICONumber: 'TICO Number',
    nationalTour: 'National Tour Association',
    business: 'Business Registration Number',
    socialMedia: 'Social Media',
    businessReferral: 'Business Referral',
    google: 'Google/Search',
    searchEngine: 'Search Engine',
    legalCompanyName: 'Legal Company Name',
    logo: 'Logo',
    fillInYour: 'Fill in your registration number',
    address: 'Address',
    country: 'Country',
    selectNationality: 'Select Nationality',
    stateOrProvince: 'State or Province',
    stateProvince: 'State/Province',
    city: 'City',
    postalCode: 'Postal/Zip Code',
    firstName: '* First Name',
    lastName: '* Last Name',
    email: '* Email',
    userName: '* User Name',
    companyWebsite: 'Company Website',
    howDidYouHear: 'How did you hear about us'
  },
  agentReg: {
    title: 'Register as a Travel Agent/Agency',
    title2: 'Registering with TripToGo is quick, free and comes with these perks.',
    fullCommissions: 'Full commissions',
    onlineBooking: '24/7 online booking',
    onlineReservation: 'Online reservation, pricing and booking management',
    easyAccess: 'Easy access to product inventory and availability',
    makeAPayment: 'Make a Payment',
    setPassword: 'Set Password',
    newToTripToGo: 'New to TripToGo?',
    createAnAccount: 'Create an account now!',
    Step1Of2: 'Step 1 of 2',
    yourInformation: 'Your Information',
    mobilePhoneNumber: 'Mobile phone number',
    Step2Of2: 'Step 2 of 2',
    agencyInformation: 'Agency Information',
    agencyName: 'Agency Name',
    agencyAddress: 'Agency Address',
    agencyEmailAddress: 'Agency Email Address',
    agencyWebsite: 'Agency Website',
    passwordsMatch: 'Please make sure your passwords match.',
    invalidNumberFormat: 'Invalid number format',
    verify: 'Verify',
    save: 'Save'
  },
  agentFaq: {
    gotSomeQuestion: 'Got some questions on how to partner with us?',
    whyPartnerWith: 'Why Partner With TripToGo',
    AccessTo24: 'Access to 24/7 chat support',
    connectWith: 'Connect with Agent Support anytime at',
    realTime: 'Real-time inventories',
    bookingManagement: 'Booking management and report',
    marketingLibrary: 'Marketing Library',
    bookingTools: 'Booking tools',
    FAMTrips: 'FAM trips available',
    chooseYourDestination: 'Choose your destination',
    enterAll: 'Enter all the required information',
    bookYourTrip: 'Book your trip',
    getThe: 'Get the confirmation number',
    agentFAQ: 'Agent FAQ'
  },
  contact: {
    contactNumber: 'Contact Number',
    writeYourMessage: 'Write your message',
    agentWriteYourMessage: "What's your question about partnering with us?",
    message: 'Message',
    location: 'Location',
    canadaOffice: 'Canada Office',
    address1_1: '675 Cochrane Dr, East Tower Suite 302',
    address1_2: 'Markham, ON L3R 0B8',
    USAOffice: 'USA Office',
    address2_1: '590 Madison Ave, 2lst Floor,',
    address2_2: 'New York City, NY 10022',
    officeHours: 'Office Hours',
    AMToPM: '9:30 AM to 5:30 PM (Mon - Fri)',
    generalInquiries: 'General Inquiries',
    agentGeneralInquiries: 'Travel Agent Inquiries',
    haveAQquestion: 'Have a question?',
    yourMessageSent: 'Your message sent! Thanks for your support!',
    contactUs: 'Contact Us',
    agentContactUs: '<BR>Travel Agent Support &<BR>Collaboration'
  },
  visa: {
    ifYouNeed: 'If you need assistance, please call 1-877-908-9878.',
    australia: 'Australia',
    argentina: 'Argentina',
    brazil: 'Brazil',
    cambodia: 'Cambodia',
    canada: 'Canada',
    china: 'China',
    cuba: 'Cuba',
    cyprus: 'Cyprus',
    ecuador: 'Ecuador',
    egypt: 'Egypt',
    europe: 'Europe',
    fiji: 'Fiji',
    hongKong: 'Hong Kong',
    india: 'India',
    indonesia: 'Indonesia',

    japan: 'Japan',
    kenya: 'Kenya',
    malaysia: 'Malaysia',
    maldives: 'Maldives',
    mexico: 'Mexico',
    morocco: 'Morocco',
    newZealand: 'New Zealand',
    peru: 'Peru',
    philippines: 'Philippines',
    singapore: 'Singapore',
    slovakia: 'Slovakia',
    southKorea: 'South Korea',
    sriLanka: 'Sri Lanka',

    taiwan: 'Taiwan',
    thailand: 'Thailand',
    turkiye: 'Türkiye',
    unitedArabEmirates: 'United Arab Emirates',
    unitedKingdom: 'United Kingdom',
    US: 'U.S.',
    vietnam: 'Vietnam',
    visaRequirement: 'Visa Requirement'
  },
  faq: {
    frequentlyAsked: 'Frequently Asked Questions',
    goBackToHomepage: 'Go Back to Homepage',
    myAccount: 'My Account'
  },
  insurance: {
    quoteUnavailable:
      'The insurer could not provide a quote. Please verify each traveler\'s information and try again.',
    travelerAgeLimitExceeded: 'This traveler is older than the maximum age covered by this plan.',
    theArchRoamRight_1:
      'The Arch RoamRight Travel Protection Plan is underwritten by Arch Insurance Company. ',
    here: 'Here',
    theArchRoamRight_2: '',
    archInsurancecompany:
      'Arch Insurance company and TripToGo are independent entities with no corporate affiliation.'
  },
  partner: {
    whyPartnerWith1: 'Why Partner With',
    whyPartnerWith2: '',
    whatsInIt: "What's in it for you",
    savings: 'Savings',
    boostExposure: 'Boost Exposure',
    audienceData: 'Audience Data and Targeted Marketing',
    increasedBookings: 'Increased Bookings and Revenue'
  },
  mine: {
    personalInformation: 'Personal Information',
    agencyID: 'Agency ID',
    memberNumber: 'Member Number',
    changePassword: 'Change Password',
    infoSuccess: 'Success! You infomation changed successfully.',
    pwdSuccess: 'Success! You password changed successfully.',
    fillOldPassword: 'Please fill in old password',
    filePassword: 'Please fill new password',
    confirmPassword: 'Please confirm your password',
    passwordNotMatch: "Your confirm password doesn't match",
    updateSuccessfully: 'update successfully!',
    travelersNetwork: 'Travelers Network',
    partnerVintageProgram: 'Partner Vintage Program',
    password: {
      changePassword: 'Change Password',
      SMSVerification: 'SMS verification',
      sendCode: 'Send code',
      yourTelephone: 'Your Telephone',
      SMSCode: 'SMS Code',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      yourNewPassword: 'Your New Password',
      confirmYourPassword: 'Confirm Your Password',
      successfully: 'Your password has been changed successfully.',
      enterNewPassword: 'Please enter your new password',
      enterTelephone: 'Please enter your telephone number.',
      enterSMSCode: 'Please enter your SMS code',
      resendCode1: 'Resend code in ',
      resendCode2: 's'
    },
    menu: {
      welcome: 'Welcome',
      logout: 'Logout'
    },
    wish: {
      yourFavorites: 'Your Favorites, All in One Place!',
      keeyTrackOf: 'Keep track of your top destinations and must-do activities right here.',
      viewDetails: 'View Details'
    },
    bookings: {
      myBookings: 'My Bookings',
      accessAllYour: 'Access all your booking details in one place.',
      bookingID: 'Booking ID',
      refundInfo: 'Refund Info',
      copySuccessful: 'Copy Successful',
      groupLink: 'Group Link',
      detail: 'Detail'
    },
    groupLink: {
      linkBooking: 'Link booking',
      travelingWithFriends: 'Traveling with friends or family? Link Your Bookings Together!',
      totalTravelers: 'Total travelers in the group',
      yourGroupLinkOrder: 'Your Group Link Order',
      unlinkThisGroup: 'Unlink this group link order',
      unlink: 'Unlink',
      link: 'Link',
      ifYouHaveAGroup: "If you have a group code from your group, enter it and click 'Link.'",
      ifYouDontHave: 'If you don’t have a group code, create here:',
      createNew: 'Create New'
    },
    wallet: {
      available: 'Available',
      availableCoins: 'Available TTG Coins',
      pointsPlainLabel: 'Points',
      pointsCurrencyLabel: 'Reward Points',
      YourWalletDetails: 'Your wallet details',
      issueDate: 'Issue Date',
      pointsEarned: 'Points Earned',
      referral: 'Referral',
      redeemedDate: 'Redeemed Date',
      redeemedPoints: 'Redeemed Points',
      appliedTowards: 'Applied Towards',
      availablePoints: 'Available Points',
      of500RewardPoints: 'of 500.00 reward points',
      travelMore: 'Travel More, Earn More',
      unlockYour: 'Unlock your next TripToGo with TTG Points!',
      from: 'From',
      earn: 'Earn',
      repeat: 'Repeat',
      redeem: 'Redeem',
      backToMyWallet: 'Back to My Wallet',
      expirationDate: 'Expiration Date',
      issued: 'Issued',
      refunded: 'Refunded',
      refundedAmount: 'Refunded Amount',
      receivedAmount: 'Amount Received',
      giftCardRedeemed: 'Gift Card Redeemed',
      paymentDate: 'Payment Date',
      availableFund: 'Available Fund',
      cardWithdrawalCutoffDate: 'Card Withdrawal Cutoff Date',
      cardWithdrawalCutoffTooltip: 'If you prefer to withdraw the TTG Coins to the original payment card, this can be done within 18 months from the original payment date. After 18 months, the amount will be issued via check. Please note that transaction and mailing fees may apply.',
      appliedToBooking: 'Applied to Booking',
      withdrawCard: 'Withdraw (Card)',
      withdrawCheck: 'Withdraw (Check)',
      withdrawalPendingCard: 'Withdrawal Pending (Card)',
      withdrawalPendingCheck: 'Withdrawal Pending (Check)',
      withdrawnCard: 'Withdrawn (Card)',
      withdrawnCheck: 'Withdrawn (Check)',
      withdrawalCancelledCard: 'Withdrawal Cancelled (Card)',
      withdrawalCancelledCheck: 'Withdrawal Cancelled (Check)',
      pendingWithdrawal: 'Pending Withdrawal',
      withdrawn: 'Withdrawn',
      used: 'Used',
      available: 'Available',
      pending: 'Pending',
      cancel:'Cancel',
      expire:'Expired',
      withdraw: 'Withdraw',
      // Withdrawal related translations
      ttgCoinsWithdrawal: 'TTG Coins Withdrawal',
      withdrawalDescription: 'TTG Coins can be applied to other purchases. If you prefer to withdraw the TTG Coins to the original payment card, this can be done within 18 months from the original payment date. After 18 months, the amount will be issued via check. Please note that transaction and mailing fees may apply.',
      withdrawalReviewNotice: 'All withdrawal requests are subject to review. Please allow 4–6 weeks for approval and processing.',
      withdrawalAvailableSince: 'Available for withdrawal since',
      toOriginalCard: 'To Original Payment Card',
      byMailingCheck: 'By Mailing Check',
      withdrawalAmount: 'Withdrawal Amount',
      enterAmount: 'Enter amount',
      invalidAmount: 'Please enter a valid amount',
      amountTooSmall: 'The withdrawal amount is too small to process. Please try again.',
      amountExceedsBalance: 'The withdrawal amount cannot exceed your total points balance.',
      cardTransferNote: 'The amount will be transferred back to credit card',
      payToOrderOf: 'Pay To The Order Of',
      payeeNamePlaceholder: "Check Recipient's Full Name",
      mailingAddress: 'Mailing Address',
      mailingAddressPlaceholder: 'Enter your mailing address',
      requiredField: 'This field is required',
      acceptPolicy: 'I accepted the',
      refundPolicy: 'Refund Policy',
      back: 'Back',
      submit: 'Submit',
      confirmation: 'Confirmation',
      confirmIntro: 'Please confirm the following information:',
      transferToCard: 'Transfer to credit card',
      mailByCheck: 'Mail by check',
      payableTo: 'Payable to',
      mailingTo: 'Mailing to',
      transactionFee: 'Transaction Fee',
      mailingFee: 'Mailing Fee',
      totalWithdrawalAmount: 'Total Withdrawal Amount',
      confirm: 'Confirm',
      processing: 'Processing...',
      successful: 'Successful!',
      withdrawalRequestSubmitted: 'Withdrawal Request Submitted',
      successMessage: 'Your withdrawal request has been submitted for review, and the requested TTG Coins are now reserved. Approval and processing typically take 4–6 weeks. No refund to your original payment card has been completed yet. You can track the request status in My Wallet.',
      partialSuccessMessage: 'Your withdrawal request has been submitted for review, and the requested TTG Coins are now reserved. Approval and processing typically take 4–6 weeks. No card refund or check payout has been completed yet. You can track the request status in My Wallet.',
      autoCardProcessingFailedMessage: 'Your withdrawal request has been submitted for review. We could not complete the original-card transfer automatically just now, but the request has been recorded and will continue to be processed by our team. Approval and processing typically take 4–6 weeks.',
      error: 'Error',
      errorMessage: 'Sorry that an unforeseeable error has occurred. Please get in touch with us.',
      cardWithdrawalAmountExceeds: 'The amount entered exceeds the balance currently eligible for original-card withdrawal.',
      checkWithdrawalAmountExceeds: 'The amount entered exceeds the balance currently eligible for check withdrawal.',
      refreshAndTryAgain: 'Your session information is out of date. Please refresh the page and try again.',
      withdrawalTryAgainLater: 'We could not submit your withdrawal request right now. Please try again later.',
      goToHelpdesk: 'Go to Helpdesk',
    },
    inquiry: {
      gotQuestions: 'Got Questions? We’ve Got Answers!',
      weAreHere1:
        'We’re here to help with all your travel plans. Whether you need details about bookings, destinations,',
      weAreHere2: 'or anything in between, just drop us a message and we’ll get back to you soon.',
      operatedBy1: 'Operated by',
      operatedBy2: '',
      message: 'Message',
      messages: 'Messages',
      enquiryDetails: 'Enquiry Details',
      haveQuestionsAbout:
        "Have questions about the tour? Leave a message for the operator below, and they'll get back to you within 48 business hours."
    },
    helpDesk: {
      bookingHelpdesk: 'Booking Helpdesk',
      haveQuestionsAbout:
        "Have questions about the tour? Leave a message for the operator below, and they'll get back to you within 48 business hours.",
      TTGTravelExpert: 'TTG Travel Expert',
      rateReply: 'How was the latest reply?',
      ratingScale: 'Rating from 1 to 5 stars',
      ratingFeedback: 'Optional feedback about this reply',
      saveRating: 'Save rating',
      savingRating: 'Saving…',
      ratingThanks: 'Thank you for your feedback.',
      ratingError: 'Could not save rating.'
    },
    story: {
      travelInspireEarn: 'Travel, Inspire & Earn',
      myStories: 'My Stories',
      draftAStory: 'Draft a story',
      published: 'Published',
      pending: 'Pending'
    },
    draft: {
      myStories: 'My Stories',
      title: 'Title',
      regionProvince: 'Region/Province',
      selectStateProvince: 'Select State/Province',
      photos: 'Photos (maximum upload 9 photos)',
      uploadPhotos: 'Upload Photos',
      publish: 'Publish',
      congratulations: 'Congratulations!!!',
      thankYouForTraveling: 'Thank you for traveling with us! Your travel story has been uploaded.',
      seeMyStories: 'See My Stories',
      goBackToHomepage: 'Go back to homepage'
    },
    network: {
      shareYourLink: 'Share your link',
      copyYourLink: 'Copy your link',
      emailYourInvite: 'Email your invite',
      sendByEmail: 'Send by email',
      howDoesItWork: 'How does it work?',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
      aFriendRegistersWithUs: 'A friend registers with us',
      itsAWin: "It's a Win-Win",
      referrals: 'Referrals',
      creationDate: 'Creation Date',
      statusOfReward: 'Status of Reward',
      shareSuccDesc: 'Success! We have sent your friend an email.',
      youHaveNoReferred: 'You have no referred friends yet!',
      yourFriendsEmail: "Your friend's email"
    },
    newsletter: {
      newsletter: 'Newsletter',
      newslettersToGo: 'Newsletters ToGo',
      wouldYouLike: '"Would you like to join our newsletter for exciting updates and offers?"',
      successful: 'Successful',
      thankYou: 'Thank you for subscribing!',
      thankYouAgain: 'Thank you for subscribing again!',
      unsubscribed: 'Unsubscribed Successful',
      sorryToSeeYouGo: 'Sorry to see you go! ',
      hasBeenUnsubscribed: 'has been successfully unsubscribed.',
      youWillStill:
        '*You will still receive all essential communications regarding your bookings and inquiries. ',
      subscribeAgain: 'Subscribe again',
      unsubscribedBy: 'Unsubscribed by accident? '
    },
    agentInfo: {
      travelAgentInfo: 'Travel Agent Information',
      primaryContact: 'Primary Contact Information',
      companyName: 'Company Name',
      agencyAdress: 'Agency Adress',
      pseudoCityCode: 'Pseudo City Code',
      accreditationNumbers: 'Accreditation Numbers',
      licenseNumber: 'License Number',
      companyAffiliations: 'Company Affiliations',
      consortia:
        'Consortia/ Tour Operator/ Independent Travel Advisor/Travel Agent/ Headquarter/ Branch',
      numberOfEmployees: 'Number of Employees',
      annualSalesVolume: 'Annual Sales Volume',
      agencyLogo: 'Agency Logo',
      noImageUploaded: 'No Image Uploaded',
      mainLogo: 'Main Logo',
      socialMediaHandle: 'Social Media Handle',
      associatedAccounts: 'Associated Accounts',
      noAccountsFound: 'No matching accounts found',
      showMoreAccounts: 'Show {count} more accounts',
      showMainAccount: 'Show main account only',
      mainAccount: 'Main Account',
      addAccount: 'Add Account',
      removeAccount: 'Remove',
      confirmRemoveAccount: 'Remove this account from your agency?',
      regeneratePassword: 'Regenerate Password',
      confirmRegeneratePassword: "Generate a new temporary password for this account? Their current password will stop working.",
      newTempPasswordLabel: 'New temporary password:',
      errorMessage: 'Something went wrong. Please try again.'
    },
    partner: {
      partnerVintage: 'Partner Vintage Program',
      attractiveIncentives: 'Attractive Incentives',
      professionalAndPrompt: 'Professional and Prompt Support',
      collaborativeSuccess: 'Collaborative Success',
      vintageTiers: 'Vintage Tiers',
      annualSalesRevenue: 'Annual Sales Revenue (USD)',
      baseIncentive: 'Base Incentive',
      overrideBonus: 'Override Bonus',
      totalCommission: 'Total Commission',
      partnerVintageProgramy: 'Partner Vintage Program Policy',
      annualSalesRevenue: 'Annual Sales Revenue',
      baseIncentive: 'Base Incentive',
      overrideBonus: 'Override Bonus',
      gogogo: 'Gogogo...',
      totalCommission: 'Total Commission',
      conditionsApply: 'Conditions apply'
    }
  },
  social: {
    facebook: 'Facebook',
    x: 'X',
    youtube: 'Youtube',
    tiktok: 'Tiktok',
    instragram: 'Instragram',
    tiktok: 'Tiktok'
  },
  mobileNav: {
    home: 'Home',
    aiChat: 'AI Chat',
    cart: 'Cart',
    account: 'Account',
    support: 'Support'
  },
  travelExplorer: {
    nav: {
      about: 'About',
      howItWorks: 'How It Works',
      contentGuidelines: 'Content Guidelines',
      claimRewards: 'Claim Your Rewards',
    },
    hero: {
      title: 'Travel Explorer',
      subtitle: 'Share Your Journey, Earn Rewards',
    },
    earnings: {
      videoPoints: '100 pts per Video',
      photoPoints: '50 pts per Photo',
    pointValue: '1 Point = 1 Product Value',
      maxPerTrip: 'Max 300 pts per booking',
      validPeriod: 'Valid for 1 year',
    },
    howItWorks: {
      title: 'How It Works',
      videoCard: {
        title: 'Video Reviews',
        points: '100 PTS',
        spec: '15–60 seconds',
        description: 'Share a short video of your trip experience on social media.',
      },
      photoCard: {
        title: 'Photo Posts',
        points: '50 PTS',
        spec: '3–10 high-quality photos',
        description: 'Post a photo series with captions about your travel experience.',
      },
      pointSystem: {
        title: 'Points System',
        conversionLabel: '1 Point = 1 Product Value',
        maxLabel: 'Up to 300 pts per booking',
        expiryLabel: 'Points valid for 1 year',
      },
    },
    guidelines: {
      title: 'Content Guidelines',
      pillar1: {
        title: 'Format Selection',
        description: 'Choose the right format for your content. Use video for dynamic experiences or photos for scenic highlights.',
      },
      pillar2: {
        title: 'Strategic Keyword Integration',
        description: 'Include required hashtags in your post to qualify for points.',
        requiredTags: 'Required: #TripToGo #Destination #review',
        captionExampleLabel: 'Caption Example',
        captionExample: 'Just back from an amazing trip to [Destination] with @triptogo_usa! The [highlight] was absolutely breathtaking. Highly recommend this package for anyone looking for [experience type]. #TripToGo #Destination #review',
      },
      pillar3: {
        title: 'Official Account Tagging',
        description: 'Tag our official accounts so we can verify your submission.',
        tiktok: 'TikTok: @triptogo',
        instagram: 'Instagram: @triptogo_usa',
        facebook: 'Facebook: @triptogo.usa',
        youtube: 'YouTube: @TripToGo_explore',
      },
      tips: {
        title: 'TripToGo Tips',
        craftingTitle: 'Crafting Compelling Reviews',
        craftingBody: 'Focus on authentic moments, honest opinions, and specific details that help fellow travelers. Mention what made the trip special — the guide, the hotel, a hidden gem — and your content will resonate more and earn more engagement.',
      },
    },
    claimSteps: {
      title: 'Claim Your Rewards',
      step1: {
        title: 'Gather Your Materials',
        description: 'Collect your post link, personal screenshot showing your profile and post, and your TripToGo Member ID.',
      },
      step2: {
        title: 'Send Your Submission',
        description: 'Email everything to shareyourjourney@triptogo.com with subject line: "Content Creator Points - [Your Member ID]".',
      },
      step3: {
        title: 'Verification & Review',
        description: 'Our team will review your submission within 2–3 business days to verify it meets the guidelines.',
      },
      step4: {
        title: 'Points Credited',
        description: 'Once approved, points will be added to your account within 5 business days. Use Bonus Points at checkout to redeem.',
      },
      redeemInfo: 'Redeem your points at checkout. Visit your wallet to check your balance.',
      contactEmail: 'shareyourjourney@triptogo.com',
    },
    social: {
      title: 'Where to Next? Tag Us in Your Travels with TripToGo!',
      hashtags: '#TripToGo #Destination #review',
      cta: 'Start Earning Now',
    },
  },
}
